module.exports = __webpack_public_path__ + "static/media/pdp_paperEggshell.03697f9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/papertypes/pdp_paperEggshell.jpg
// module id = 1500
// module chunks = 51